import { render, staticRenderFns } from "./dropCourse.vue?vue&type=template&id=4bc91306"
import script from "./dropCourse.vue?vue&type=script&lang=js"
export * from "./dropCourse.vue?vue&type=script&lang=js"
import style0 from "./dropCourse.vue?vue&type=style&index=0&id=4bc91306&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports